import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./NewDeclaration.css";
import "./HorizontalSteps.css";
import Select from "react-select";
import DateSelector from "./DateTimeSelector";
import TimeSelector from "./TimeSelector";
import { format } from "date-fns";
import Cookies from "js-cookie";
import confetti from "canvas-confetti";
import { Link } from "react-router-dom";
import { ApiUrl } from "../../config";

const HorizontalSteps = () => {
  const token = Cookies.get("access_token");

  const modes = [
    { value: "En ligne", label: "En ligne" },
    { value: "Physique", label: "Physique" },
  ];

  const [currentStep, setCurrentStep] = useState(1);

  const [villes, setVilles] = useState([]); // Options for villes
  const [selectedVille, setSelectedVille] = useState(null); // Selected ville
  const [centers, setCenters] = useState([]); // Options for centers
  const [selectedCenter, setSelectedCenter] = useState(null); // Selected center
  const [isCentersDisabled, setIsCentersDisabled] = useState(true);
  const [selectedMode, setSelectedMode] = useState(modes[1]);
  // const [description, setDescription] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const [disabledTimes, setDisabledTimes] = useState({}); // State for disabled times
  const [errorMessage, setErrorMessage] = useState("");
  const [SuccessMessage, setSuccessMessage] = useState("");
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const handleDisabledTimesChange = (times) => {
    setDisabledTimes(times);
  };

  const formattedDate = selectedDate
    ? format(new Date(selectedDate), "yyyy-MM-dd") // Use the correct format
    : "";

  const steps = [
    { id: 1, label: "Informations" },
    { id: 2, label: "Date " },
    { id: 3, label: "Heure" },
    { id: 4, label: "Fin" },
  ];

  const goToStep = (step) => {
    setCurrentStep(step);
  };

  const selectTime = (time) => {
    setSelectedTime(time);
  };

  const formData = {
    center_id: selectedCenter ? selectedCenter.value : null,
    type_rdv: selectedMode ? selectedMode.value : null,
    // description: description,
    heure_rdv: selectedTime ? selectedTime + ":00" : null,
    date_rdv: formattedDate,
  };

  const validateForm = () => {
    let error = "";
    setErrorMessage("");
    setSuccessMessage("");

    // Validate based on the current step
    if (currentStep === 1) {
      if (!formData.center_id) {
        error = "Veuillez choisir votre centre.";
      } else if (!formData.type_rdv) {
        error = "Veuillez choisir un type de Rendez-vous.";
      }
    } else if (currentStep === 2) {
      if (!formData.date_rdv) {
        error = "Veuillez entrer une date de rendez-vous.";
      }
    } else if (currentStep === 3) {
      if (!formData.heure_rdv) {
        error = "Veuillez entrer une heure de rendez-vous.";
      }
    }
    if (error) {
      //  this.errorMessage = error;
      setErrorMessage(error);
      console.log(errorMessage);
      return false;
    } else {
      setErrorMessage("");
      return true;
    }
  };

  const validationDone = () => {
    if (!validateForm()) {
      return;
    }
    setCurrentStep(currentStep + 1);
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    setLoadingSubmit(true);
    const formData = {
      center_id: selectedCenter ? selectedCenter.value : null,
      type_rdv: selectedMode ? selectedMode.value : null,
      // description: description,
      heure_rdv: selectedTime ? selectedTime + ":00" : null,
      date_rdv: formattedDate,
    };

    try {
      const response = await fetch(
        `${ApiUrl}citoyen-add-declaration`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );
      if (!response.ok) {
        // Handle API error
        const errorData = await response.json();
        setErrorMessage(
          errorData.errors
            ? Object.values(errorData.errors).join(", ")
            : errorData.message
        );
        setLoadingSubmit(false);
        return;
      }

      if (response.ok) {
        const data = await response.json();
        console.log("API Response:", data);
        goToStep(currentStep + 1);
        setSuccessMessage("Nous avons bien recus votre declaration!");
        this.triggerConfetti();
      }
      setErrorMessage("");
    } catch (error) {
      console.error("Error submitting declaration:", error);
    } finally {
      setLoadingSubmit(false); // Stop loading
    }
  };

  // Fetch villes on component mount
  useEffect(() => {
    fetch(`${ApiUrl}all-villes`)
      .then((response) => response.json())
      .then((data) => {
        const options = data.map((ville) => ({
          value: ville, // The actual value used for the dropdown
          label: ville, // The display text in the dropdown
        }));
        setVilles(options);
      })
      .catch((error) => console.error("Error fetching villes:", error));
     // setLoadingSubmit(true);
  }, []);

  // Fetch centers when a ville is selected
  useEffect(() => {
    if (selectedVille) {
      fetch(`${ApiUrl}centers/${selectedVille.value}`)
        .then((response) => response.json())
        .then((data) => {
          const options = data.map((center) => ({
            value: center.id, // Use the center's ID as the value
            label: center.name, // Use the center's name as the label
          }));
          setCenters(options);
          setIsCentersDisabled(false); // Enable the centers select
        })
        .catch((error) => console.error("Error fetching centers:", error));
    } else {
      setCenters([]); // Clear centers if no ville is selected
      setIsCentersDisabled(true); // Disable the centers select
    }
  }, [selectedVille]);

  useEffect(() => {
    // Trigger the confetti when currentStep reaches 4
    if (currentStep === 4) {
      triggerConfetti();
    }
  }, [currentStep]);

  const triggerConfetti = () => {
    confetti({
      particleCount: 200, // Number of confetti particles
      spread: 70, // Spread angle of the confetti
      origin: { y: 0.6, x: 0.6 }, // The origin of the confetti animation (height, width)
    });
  };

  return (
    <div className="row">
      <div className="d-flex justify-content-between mb-3">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb breadcrumb-no-gutter">
            <li class="breadcrumb-item">
              <a class="breadcrumb-link" href="javascript:;">
                Dossiers
              </a>
            </li>
            <li
              class="breadcrumb-item active"
              style={{ color: "rgb(255, 77, 7)" }}
              aria-current="page"
            >
              Nouvelle Déclaration
            </li>
          </ol>
        </nav>
      </div>

      <div className="container form-container card ">
        <div className="card-header">
          <h5>Ajouter une Nouvelle déclaration</h5>
        </div>

        <div className="card-body">
          <div className=" container m-auto stepper d-flex justify-content-between align-items-center  mb-4">
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>
                <div
                  className={`step ${currentStep >= step.id ? "active" : ""}`}
                >
                  <div className="step-circle">{step.id}</div>
                  <div className="step-label">{step.label}</div>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`step-line ${
                      currentStep > step.id ? "active" : ""
                    }`}
                  ></div>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Step Content */}
          <div className="step-content p-4 rounded shadow-sm">
            {errorMessage && (
              <div className="alert alert-danger">{errorMessage}</div>
            )}
            {currentStep === 1 && (
              <div>
                <form>
                  {/* Ville */}
                  <div className="mb-3">
                    <label htmlFor="ville" className="form-label">
                      Ville
                    </label>
                    <Select
                      value={selectedVille}
                      onChange={(option) => setSelectedVille(option)}
                      options={villes}
                      placeholder="Select a ville"
                      isSearchable={true}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "10px", // Apply border radius here
                          boxShadow: "none", // Optional: Remove box shadow
                          "&:hover": {},
                        }),
                      }}
                    />
                  </div>

                  {/* Centres */}
                  <div className="mb-3">
                    <label htmlFor="center" className="form-label">
                      Sélectionner un centre
                    </label>
                    <Select
                      id="form-select simple-input"
                      options={centers}
                      value={selectedCenter}
                      onChange={(option) => setSelectedCenter(option)}
                      placeholder="Select a center..."
                      isDisabled={isCentersDisabled}
                    />
                  </div>

                  {/* Mode */}
                  <div className="mb-3">
                    <label htmlFor="mode" className="form-label">
                      Mode
                    </label>

                    <Select
                      value={selectedMode}
                      onChange={setSelectedMode}
                      options={modes}
                      placeholder="Séléctionnez un mode"
                      id="mode"
                      name="mode"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "10px", // Apply border radius here
                          boxShadow: "none", // Optional: Remove box shadow
                          "&:hover": {},
                        }),
                      }}
                    />
                  </div>

                  {/* Description */}
                  {/* <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      id="description"
                      name="description"
                      rows="4"
                      value={formData.description}
                      onChange={(e) => setDescription(e.target.value)}
                      className="form-control simple-input"
                      placeholder="Entrez une description détaillée..."
                    ></textarea>
                  </div> */}
                </form>
              </div>
            )}
            {currentStep === 2 && (
              <div>
                <div className="d-flex justify-content-between">
                  <div className="">
                    <h4>Étape 2 : Date</h4>
                    <p>Sélectionnez une date pour votre rendez-vous.</p>
                  </div>
                  <div>
                    <input
                      type="text"
                      name="prenom"
                      value={formattedDate}
                      className="form-control"
                      placeholder="Date:"
                      disabled
                    />
                  </div>
                </div>
                {/* <DateRdv /> */}
                <DateSelector
                  selectedCenter={selectedCenter}
                  selectedDate={selectedDate}
                  onDateChange={setSelectedDate}
                  onDisabledTimesChange={handleDisabledTimesChange} // Callback for disabledTimes
                />
              </div>
            )}
            {currentStep === 3 && (
              <div>
                <h4>Étape 3 : Heure</h4>
                <p>Choisissez une heure pour finaliser.</p>
                <TimeSelector
                  disabledTimes={disabledTimes}
                  selectedDate={selectedDate}
                  onTimeSelect={(time) => {
                    selectTime(time);
                  }}
                />
              </div>
            )}

            {currentStep === 4 && (
              <div
                style={{
                  textAlign: "center",
                  backgroundColor: "#fff",
                  padding: "30px",
                }}
              >
                {SuccessMessage && (
                  <div className="alert alert-success">{SuccessMessage}</div>
                )}
                <img
                  src="/assets/illustration/24 - Successful startup.png"
                  alt="Success Illustration"
                  style={{ width: "300px", marginBottom: "20px" }}
                />
                <h1
                  style={{
                    fontSize: "2rem",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  Thank you!
                </h1>
                <p style={{ fontSize: "1.2rem", marginBottom: "20px" }}>
                  Your submission is received and we will contact you soon.
                </p>
                <Link
                  to={"/mon-espace/mes-declarations"}
                  className="btn btn-base"
                >
                  ← Retour à l'accueil
                </Link>
                <br />
              </div>
            )}
          </div>

          {/* Navigation Buttons */}
          <div className="mt-4 d-flex justify-content-between">
            {/* Conditionally render "Précédent" button */}
            {currentStep > 1 && currentStep < steps.length && (
              <button
                className="btn btn-outline-secondary"
                onClick={() => goToStep(currentStep - 1)}
              >
                Précédent
              </button>
            )}

            {/* Conditionally render "Suivant" button */}
            {currentStep < steps.length && currentStep !== steps.length - 1 && (
              <button className="btn btn-base" onClick={validationDone}>
                Suivant
              </button>
            )}
            {currentStep === steps.length - 1 && (
              <button
                type="submit"
                className="btn btn-base"
                onClick={handleSubmit}
                disabled={loadingSubmit}
              >
                {loadingSubmit ? <span className="loader"></span> : "Submit"}
              </button>
            )}

            {/* "Please Wait" Modal */}
            {loadingSubmit && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <div className="loader"></div> {/* Add a spinner here */}
                  <p>Please wait...</p>
                </div>
              </div>
            )}

            {/* {currentStep === steps.length - 1 && (
              <button
                type="submit"
                className="btn btn-base"
                onClick={() => handleSubmit()}
              >
                Submit
              </button>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HorizontalSteps;
